import ScoreForm from './ScoreForm.view';

export default ScoreForm;
